import React, { useCallback, useEffect, useRef } from 'react'
import { ModalProps, useModal } from '../../context/ModalContext'
import './ModalCe.scss'

const ModalCe = ({
    titleModal,
    textModal,
    primaryBtn,
    secondaryBtn,
    textPrimaryBtn,
    textSecondatyBtn,
    onClickPrimaryBtn,
    OnClickSecondaryBtn,
    ...props
}:ModalProps) => {

    const { closeModal } = useModal()
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      modalRef.current?.focus();
    }, [])
    
    const handleKeyDown = useCallback((e: React.KeyboardEvent)=>{
        if (e.key === "Tab") {
            e.preventDefault();
            modalRef.current?.focus();
        }
    },[]);
    const handleKeyDownShift = useCallback((e: React.KeyboardEvent)=>{
        if (e.shiftKey) {
            e.preventDefault();
            modalRef.current?.focus();
        }
    },[]);

  return (
    <>
        <div className='ce-als-modal-bg'></div>
        <div className='ce-als-modal ce-als-modal--opened' 
        id='ce-als-modal' 
        tabIndex={0} 
        ref={modalRef} 
        onKeyDown={handleKeyDownShift}
        role='alertdialog'
        aria-modal={true}
        aria-labelledby='dialog_label'
        aria-describedby='dialog_desc'
        >
            <div className="ce-als-modal__btn-close" data-dismiss="modal" onClick={closeModal}><span aria-hidden="true">&times;</span></div>
            <div className='ce-als-modal__content oswald400 uppercase'>
                <div className='ce-als-modal__title-text'>
                    <h2 className='' id='dialog_label'>{titleModal} </h2>
                    <p className='' id='dialog_desc'>{textModal}</p>
                </div>
                <div className='ce-als-modal__buttons'>
                    {primaryBtn?
                        <button onClick={onClickPrimaryBtn} onKeyDown={secondaryBtn? undefined: handleKeyDown} className=''>{textPrimaryBtn} </button>
                        :<></>
                    }
                    {secondaryBtn?
                        <button onClick={OnClickSecondaryBtn} onKeyDown={handleKeyDown} className=''>{textSecondatyBtn} </button>
                        :<></>
                    }
                </div>
            </div>
        </div>
    </>
  )
}

export default ModalCe